import { GridOptions } from '@ag-grid-community/core'
import { NgModule } from '@angular/core'
import {
  GridOptionModule,
  GridOptionService,
  NfAgGridModule,
} from '@northfork/ag-grid-angular'
import { extendDefaultGridOptions } from './extend-grid-options'

/**
 * This module registers with northfork, so that when an nf-ag-grid is constructed, it will call extendDefaultGridOptions to add gridOptions on top of the defaults that nf-ag-grid applies.
 */
@NgModule({
  imports: [
    NfAgGridModule.forRoot({
      theme: 'ag-theme-northfork-compact',
      autoResize: false,
    }),
  ],
  exports: [NfAgGridModule],
})
export class HeliosAgGridConfigModule extends GridOptionModule {
  constructor(gridOptionService: GridOptionService) {
    super(gridOptionService)
  }

  protected extendGridOptions(gridOptions: GridOptions) {
    return extendDefaultGridOptions(gridOptions)
  }
}
